export default "__VITE_ASSET__BwB3IFNB__"